import { useTranslation } from 'react-i18next';

interface CategoryBadgeProps {
  category: string;
}

const categoryColors: Record<string, string> = {
  customer_order: 'bg-blue-100 text-blue-700 border-blue-300',
  order_change: 'bg-sky-100 text-sky-700 border-sky-300',
  delivery_update: 'bg-indigo-100 text-indigo-700 border-indigo-300',
  pickup_request: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  supplier_issue: 'bg-red-100 text-red-700 border-red-300',
  inventory_shortage: 'bg-rose-100 text-rose-700 border-rose-300',
  production_task: 'bg-purple-100 text-purple-700 border-purple-300',
  roasting_request: 'bg-amber-100 text-amber-700 border-amber-300',
  packaging_request: 'bg-orange-100 text-orange-700 border-orange-300',
  invoice_or_payment: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  followup_needed: 'bg-yellow-100 text-yellow-700 border-yellow-300',
  reminder: 'bg-teal-100 text-teal-700 border-teal-300',
  urgent_issue: 'bg-red-100 text-red-800 border-red-400',
  general_information: 'bg-gray-100 text-gray-600 border-gray-300',
  noise: 'bg-gray-50 text-gray-400 border-gray-200',
};

export default function CategoryBadge({ category }: CategoryBadgeProps) {
  const { t } = useTranslation();
  const colors =
    categoryColors[category] ?? 'bg-gray-100 text-gray-600 border-gray-300';

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${colors}`}
    >
      {t(`categories.${category}`, category)}
    </span>
  );
}
